import { BaseApiService } from '@/shared/api/BaseApiService';

export interface ProcedureCatalogItem {
  id: string;
  name: string;
  code: string;
  categoryId: string;
  duration: number | null;
  defaultDurationMin: number;
  totalFeePaise: number | null;
  isActive: boolean;
}

export interface ProcedureCategory {
  id: string;
  name: string;
  color: string;
  count: number;
}

export interface ProcedureCatalogParams {
  categoryId?: string;
  search?: string;
  isActive?: boolean;
  page?: number;
  limit?: number;
}

export interface ProcedureCatalogResponse {
  items: ProcedureCatalogItem[];
  total: number;
}

export class ProcedureCatalogService extends BaseApiService {
  protected readonly resourcePath = 'procedure-catalog';

  async list(params?: ProcedureCatalogParams): Promise<ProcedureCatalogResponse> {
    return this.get('', { params });
  }

  async listCategories(): Promise<ProcedureCategory[]> {
    return this.get('/categories');
  }
}

export const procedureCatalogService = new ProcedureCatalogService();
